import { render, staticRenderFns } from "./ContactMainWrapper.vue?vue&type=template&id=5053cec7&"
import script from "./ContactMainWrapper.vue?vue&type=script&lang=js&"
export * from "./ContactMainWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports